import React, { useEffect, useState } from "react";
import refreshLogo from "../img/refreshLogo.svg";
import Expand_down from "../img/Expand_down.svg";
import Add_round from "../img/Add_round.svg";
import api from "../../api/axiosInstance";
import { motion, AnimatePresence } from "framer-motion";
import Add_roundWhite from "../img/Add_roundWhite.svg";
import { useNavigate } from "react-router-dom";

const CreateAddOn = () => {
  const navigate = useNavigate();
  const [selectedProjectName, setSelectedProjectName] = useState("");
  const [projectId, setProjectId] = useState(null);
  const [projects, setProjects] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [durationOptions, setDurationOptions] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [apiMessage, setApiMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreProjects, setHasMoreProjects] = useState(true);
  const [isLoadingProjects, setIsLoadingProjects] = useState(false);

  const [addOnForms, setAddOnForms] = useState([
    {
      addonName: "",
      description: "",
      imageFile: null,
      imageFileName: "Upload File",
      haveLimit: true,
      limit: "",
      features: [""],
      durations: [{ duration_master_id: "", price: "", dropdownOpen: false }],
    },
  ]);

  const handleAddAnotherPlan = () => {
    setAddOnForms((prev) => [
      ...prev,
      {
        addonName: "",
        description: "",
        imageFile: null,
        imageFileName: "Upload File",
        haveLimit: true,
        limit: "",
        features: [""],
        durations: [{ duration_master_id: "", price: "", dropdownOpen: false }],
      },
    ]);
  };

  const updateFormField = (index, field, value) => {
    const updated = [...addOnForms];
    updated[index][field] = value;
    setAddOnForms(updated);
  };

  const updateFeature = (formIndex, featureIndex, value) => {
    const updated = [...addOnForms];
    updated[formIndex].features[featureIndex] = value;
    setAddOnForms(updated);
  };

  const addFeature = (formIndex) => {
    const updated = [...addOnForms];
    updated[formIndex].features.push("");
    setAddOnForms(updated);
  };

  const removeFeature = (formIndex, featureIndex) => {
    const updated = [...addOnForms];
    if (updated[formIndex].features.length === 1) {
      updated[formIndex].features[0] = "";
    } else {
      updated[formIndex].features.splice(featureIndex, 1);
    }
    setAddOnForms(updated);
  };

  const ToggleLimit = (formIndex) => {
    setAddOnForms((prev) =>
      prev.map((form, index) =>
        index === formIndex ? { ...form, haveLimit: !form.haveLimit } : form
      )
    );
  };

  useEffect(() => {
    fetchProjects();
    fetchDurations();
  }, []);

  const fetchProjects = async (page = 1) => {
    if (isLoadingProjects || !hasMoreProjects) return;

    setIsLoadingProjects(true);
    try {
      const token = localStorage.getItem("accessToken");
      const res = await api.get(`/admin-app/api/v1/list-project?page=${page}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const newProjects = res.data.data?.results || [];

      setProjects((prev) => [...prev, ...newProjects]);
      setHasMoreProjects(!!res.data.data?.next);
      setCurrentPage(page + 1);
    } catch (err) {
      console.error("Error fetching projects:", err);
    } finally {
      setIsLoadingProjects(false);
    }
  };

  const fetchDurations = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const res = await api.get("/admin-app/api/v1/list-duration", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDurationOptions(res.data.data?.results || []);
    } catch (err) {
      console.error("Error fetching durations:", err);
    }
  };

  const handleDurationSelect = (formIndex, duration, durationIndex) => {
    setAddOnForms((prev) =>
      prev.map((form, index) => {
        if (index === formIndex) {
          const updatedDurations = [...form.durations];
          updatedDurations[durationIndex] = {
            ...updatedDurations[durationIndex],
            duration_master_id: duration.id,
            dropdownOpen: false,
          };
          return { ...form, durations: updatedDurations };
        }
        return form;
      })
    );
  };

  const handleProjectTypeChange = (project) => {
    setSelectedProjectName(project.name);
    setProjectId(project.id);
    setDropdownOpen(false);
  };

  const handleAddFeature = (formIndex) => {
    setAddOnForms((prev) =>
      prev.map((form, index) => {
        if (index === formIndex) {
          return { ...form, features: [...form.features, ""] };
        }
        return form;
      })
    );
  };

  const handleFeatureChange = (formIndex, featureIndex, value) => {
    setAddOnForms((prev) =>
      prev.map((form, index) => {
        if (index === formIndex) {
          const updatedFeatures = [...form.features];
          updatedFeatures[featureIndex] = value;
          return { ...form, features: updatedFeatures };
        }
        return form;
      })
    );
  };

  const handleAddDuration = (formIndex) => {
    setAddOnForms((prev) =>
      prev.map((form, index) => {
        if (index === formIndex) {
          return {
            ...form,
            durations: [
              ...form.durations,
              { duration_master_id: "", price: "", dropdownOpen: false },
            ],
          };
        }
        return form;
      })
    );
  };

  const handleDurationChange = (formIndex, durationIndex, field, value) => {
    setAddOnForms((prev) =>
      prev.map((form, index) => {
        if (index === formIndex) {
          const updatedDurations = [...form.durations];
          updatedDurations[durationIndex][field] = value;
          return { ...form, durations: updatedDurations };
        }
        return form;
      })
    );
  };

  const toggleDurationDropdown = (formIndex, durationIndex) => {
    setAddOnForms((prev) =>
      prev.map((form, index) => {
        if (index === formIndex) {
          const updatedDurations = form.durations.map((duration, i) => ({
            ...duration,
            dropdownOpen: i === durationIndex ? !duration.dropdownOpen : false,
          }));
          return { ...form, durations: updatedDurations };
        }
        return form;
      })
    );
  };

  const handleFileChange = async (e, formIndex) => {
    const file = e.target.files[0];

    // Create a new copy of the addOnForms array
    const updatedForms = [...addOnForms];

    // Make sure the form at formIndex exists
    if (!updatedForms[formIndex]) {
      console.error(`Form at index ${formIndex} not found`);
      return;
    }

    // Update the file name immediately for better UX
    updatedForms[formIndex].imageFileName = file?.name || "Upload File";
    setAddOnForms(updatedForms);

    if (file) {
      try {
        const formData = new FormData();
        formData.append("file", file);

        const token = localStorage.getItem("accessToken");
        const res = await api.post("/admin-app/api/v1/upload-file", formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });

        if (res.data.status === "success") {
          // Create another copy to update the imageFile
          const updatedFormsWithFile = [...addOnForms];
          updatedFormsWithFile[formIndex].imageFile = res.data.data.id;
          setAddOnForms(updatedFormsWithFile);
        } else {
          console.error("Image upload failed");
          // Revert the filename if upload fails
          const updatedFormsError = [...addOnForms];
          updatedFormsError[formIndex].imageFileName = "Upload File";
          setAddOnForms(updatedFormsError);
        }
      } catch (err) {
        console.error("Upload error:", err);
        // Revert the filename on error
        const updatedFormsError = [...addOnForms];
        updatedFormsError[formIndex].imageFileName = "Upload File";
        setAddOnForms(updatedFormsError);
      }
    }
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem("accessToken");

    const errors = [];

    const addon_data = addOnForms.map((form, index) => {
      if (!form.addonName.trim()) {
        errors.push(`Add-on Title is required in plan ${index + 1}`);
      }
      if (!form.description.trim()) {
        errors.push(`Description is required in plan ${index + 1}`);
      }
      if (!form.imageFile) {
        errors.push(`Application Icon is required in plan ${index + 1}`);
      }
      if (
        form.haveLimit &&
        (!form.limit || isNaN(form.limit) || Number(form.limit) < 0)
      ) {
        errors.push(`Valid limit is required in plan ${index + 1}`);
      }

      const validDurations = form.durations.filter(
        (d) => d.duration_master_id && d.price && !isNaN(d.price)
      );

      if (validDurations.length === 0) {
        errors.push(`At least one valid duration in plan ${index + 1}`);
      }

      const validFeatures = form.features.filter((f) => f.trim());
      if (validFeatures.length === 0) {
        errors.push(`At least one feature is required in plan ${index + 1}`);
      }

      return {
        name: form.addonName,
        description: form.description,
        image: form.imageFile,
        limit: form.haveLimit ? Number(form.limit) : null,
        addon_features: validFeatures.map((f) => ({ feature: f })),
        duration_data: validDurations.map((d) => ({
          duration_master_id: d.duration_master_id,
          price: parseFloat(d.price),
        })),
      };
    });

    if (!projectId) {
      errors.push("Application Name is required");
    }

    if (errors.length > 0) {
      setApiMessage(errors[0]);
      setShowErrorModal(true);
      return;
    }

    try {
      const payload = {
        project_id: projectId,
        addon_data,
      };

      const res = await api.post("/admin-app/api/v1/create-addon", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status === "success") {
        setApiMessage(res.data.message || "Add-ons created successfully!");
        setShowSuccessModal(true);
        setAddOnForms([
          {
            addonName: "",
            description: "",
            imageFile: null,
            imageFileName: "Upload File",
            haveLimit: true,
            limit: "",
            features: [""],
            durations: [
              { duration_master_id: "", price: "", dropdownOpen: false },
            ],
          },
        ]);
      } else {
        setApiMessage(res.data.message || "Error during add-on creation.");
        setShowErrorModal(true);
      }
    } catch (err) {
      console.error("API Error:", err);
    }
  };

  const handleRemoveDuration = (formIndex, durationIndex) => {
    setAddOnForms((prev) =>
      prev.map((form, index) => {
        if (index === formIndex) {
          const updatedDurations = [...form.durations];
          if (updatedDurations.length === 1) {
            updatedDurations[0] = {
              duration_master_id: "",
              price: "",
              dropdownOpen: false,
            };
          } else {
            updatedDurations.splice(durationIndex, 1);
          }
          return { ...form, durations: updatedDurations };
        }
        return form;
      })
    );
  };

  const handleRemoveFeature = (formIndex, featureIndex) => {
    setAddOnForms((prev) =>
      prev.map((form, index) => {
        if (index === formIndex) {
          const updatedFeatures = [...form.features];
          if (updatedFeatures.length === 1) {
            updatedFeatures[0] = "";
          } else {
            updatedFeatures.splice(featureIndex, 1);
          }
          return { ...form, features: updatedFeatures };
        }
        return form;
      })
    );
  };

  const handleRemoveForm = (formIndex) => {
    if (addOnForms.length <= 1) {
      // Don't remove the last form
      setApiMessage("You must have at least one add-on plan");
      setShowErrorModal(true);
      return;
    }

    setAddOnForms((prev) => prev.filter((_, index) => index !== formIndex));
  };

  return (
    <div>
      {addOnForms.map((form, index) => (
        <div key={index} className="">
          <div className="flex justify-between items-center font-semibold text-sm bg-[#CEC7FF4D] my-5 py-2 px-4 rounded">
            <span>Add-On Details</span>
            {/* <img src={refreshLogo} alt="" className="bg-white p-1 rounded-md" /> */}
            {addOnForms.length > 1 && index > 0 && (
              <button
                onClick={() => handleRemoveForm(index)}
                className=" text-gray-400   flex items-center justify-center"
                title="Remove this plan"
              >
                ✕
              </button>
            )}
          </div>

          <div className="w-full flex flex-col gap-4 text-sm">
            <div className="flex flex-col sm:flex-row gap-5">
              <div className="w-2/3 sm:w-1/2 relative">
                <label htmlFor="" className="text-sm font-semibold ">
                  Application Name<span className="text-red-500">*</span>
                </label>
                <div
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="pl-3 h-10 pr-4 mt-1 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter bg-right bg-no-repeat focus:outline-none appearance-none flex items-center justify-between cursor-pointer"
                  style={{
                    backgroundImage: `url(${Expand_down})`,
                    backgroundPosition: "98% center",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <span
                    className={
                      selectedProjectName ? "text-black" : "text-[#9CA3AF]"
                    }
                  >
                    {selectedProjectName || "Select Application Name"}
                  </span>
                </div>

                {dropdownOpen && (
                  <div
                    className="absolute z-10 mt-1 w-full bg-white border border-[#8C8C8C4D] rounded-md shadow-sm max-h-56 overflow-y-auto"
                    onScroll={(e) => {
                      const target = e.target;
                      if (
                        target.scrollTop + target.clientHeight >=
                          target.scrollHeight - 10 &&
                        hasMoreProjects &&
                        !isLoadingProjects
                      ) {
                        fetchProjects(currentPage);
                      }
                    }}
                  >
                    {projects.length === 0 ? (
                      <div className="px-4 py-2 text-sm text-gray-500">
                        No projects found
                      </div>
                    ) : (
                      projects.map((project, idx) => (
                        <div
                          key={idx}
                          onClick={() => handleProjectTypeChange(project)}
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                        >
                          {project.name}
                        </div>
                      ))
                    )}
                    {isLoadingProjects && (
                      <div className="px-4 py-2 text-xs text-gray-400 text-center">
                        Loading...
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="flex flex-col w-full sm:w-1/2">
                <label htmlFor="" className="text-sm font-semibold ">
                  Add Title<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  className="w-full pl-3 h-10 pr-4 mt-1  border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none "
                  placeholder="Add Title"
                  value={form.addonName}
                  onChange={(e) =>
                    updateFormField(index, "addonName", e.target.value)
                  }
                />
              </div>
            </div>

            <div className="flex flex-col">
              <label htmlFor="" className="text-sm font-semibold ">
                Description<span className="text-red-500">*</span>
              </label>

              <textarea
                value={form.description}
                onChange={(e) =>
                  updateFormField(index, "description", e.target.value)
                }
                placeholder="Description"
                className="w-full pl-3 pt-2 h-16 pr-4  border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none "
              ></textarea>
            </div>

            <div className="sm:w-1/2">
              <span className="text-sm font-semibold">Application Icon<span className="text-red-500">*</span></span>
              <div className=" px-1 mt-1 flex items-center gap-6  h-10 pr-4 mr-2  border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none ">
                <input
                  type="file"
                  accept="image/*"
                  className="hidden"
                  id={`iconUpload-${index}`} // Unique ID for each form
                  onChange={(e) => handleFileChange(e, index)}
                />
                <label
                  htmlFor={`iconUpload-${index}`}
                  className="bg-primary rounded-md px-3 py-1 font-semibold text-white cursor-pointer
                  hover:scale-105 transition-transform duration-300"
                  style={{ willChange: "transform" }}
                >
                  Choose File
                </label>

                <span className="text-[#9CA3AF]">{form.imageFileName} </span>
              </div>
            </div>
            <div className="sm:w-1/2 flex gap-4">
              <div className="w-1/2 flex gap-6 items-center h-10">
                <span className="text-base font-semibold ">
                  Do you have limit ?
                </span>
                <div
                  className={`w-14 h-7 rounded-full flex items-center cursor-pointer px-1 transition-all duration-500 ease-in-out ${
                    form.haveLimit
                      ? "bg-primary justify-start"
                      : "bg-gray-200 justify-end"
                  }`}
                  onClick={() => ToggleLimit(index)}
                  style={{
                    position: "relative", // Make sure the container is positioned relatively for absolute positioning of the knob
                  }}
                >
                  <div
                    className="bg-white rounded-full w-5 h-5 transition-all duration-500 ease-in-out"
                    style={{
                      position: "absolute", // Make the knob move independently from the container
                      top: "50%", // Align vertically
                      transform: "translateY(-50%)", // Center it vertically
                      left: form.haveLimit ? "4px" : "calc(100% - 24px)", // Move the knob based on `haveLimit` state
                    }}
                  ></div>
                </div>
              </div>

              {form.haveLimit && (
                <input
                  type="number"
                  className="w-1/2 pl-3 h-10 pr-4 mr-2 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none"
                  placeholder="Add limit count"
                  value={form.limit}
                  onChange={(e) =>
                    updateFormField(index, "limit", e.target.value)
                  }
                />
              )}
            </div>

            <div className="flex justify-between items-center font-semibold text-sm bg-[#CEC7FF4D] my-3 py-2 px-4 rounded">
              <span>Set Duration</span>
              {/* <img src={refreshLogo} alt="" className="bg-white p-1 rounded-md" /> */}
            </div>
            <div className="flex flex-col gap-4">
              {form.durations.map((duration, durationIndex) => (
                <div key={durationIndex} className="w-full flex gap-5">
                  <div className="relative w-2/3 sm:w-1/2">
                    {durationIndex === 0 && (
                      <label htmlFor="" className="text-sm font-semibold ">
                        License Duration<span className="text-red-500">*</span>
                      </label>
                    )}

                    <div
                      onClick={() =>
                        toggleDurationDropdown(index, durationIndex)
                      }
                      className="pl-3 h-10 pr-4 mt-1 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter flex items-center justify-between cursor-pointer"
                      style={{
                        backgroundImage: `url(${Expand_down})`,
                        backgroundPosition: "98% center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <span
                        className={
                          duration.duration_master_id
                            ? "text-black"
                            : "text-[#9CA3AF]"
                        }
                      >
                        {duration.duration_master_id
                          ? durationOptions.find(
                              (d) => d.id === duration.duration_master_id
                            )?.name || "Invalid Duration"
                          : "License Duration"}
                      </span>
                    </div>

                    {duration.dropdownOpen && (
                      <div className="absolute z-10 mt-1 w-full bg-white border border-[#8C8C8C4D] rounded-md shadow-sm max-h-56 overflow-y-auto">
                        {durationOptions.length === 0 ? (
                          <div className="px-4 py-2 text-sm text-gray-500">
                            No durations available
                          </div>
                        ) : (
                          durationOptions.map((durationOpt) => (
                            <div
                              key={durationOpt.id}
                              onClick={() =>
                                handleDurationSelect(
                                  index,
                                  durationOpt,
                                  durationIndex
                                )
                              }
                              className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                            >
                              {durationOpt.name}
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>

                  <div className="flex flex-col w-full sm:w-1/2">
                    {durationIndex === 0 && (
                      <label htmlFor="" className="text-sm font-semibold ">
                        Platform Selling Price<span className="text-red-500">*</span>
                      </label>
                    )}

                    <div className="flex gap-4">
                      <input
                        type="number"
                        className="flex  flex-grow pl-3 mt-1 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none"
                        placeholder="Platform Selling Price"
                        value={duration.price}
                        onChange={(e) =>
                          handleDurationChange(
                            index,
                            durationIndex,
                            "price",
                            e.target.value
                          )
                        }
                      />

                      {form.durations.length > 1 && durationIndex > 0 && (
                        <button
                          type="button"
                          onClick={() =>
                            handleRemoveDuration(index, durationIndex)
                          }
                          className=" text-gray-400 hover:text-gray-300 font-bold"
                          title="Remove"
                        >
                          ✕
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}

              <div
                className="flex justify-between items-center w-32 cursor-pointer rounded-md py-2 bg-[#CEC7FF4D] px-2
                hover:bg-primary text-primary hover:text-white hover:scale-105 transition-transform duration-300 group"
                onClick={() => handleAddDuration(index)}
                style={{ willChange: "transform" }}
              >
                <img
                  src={Add_round}
                  alt=""
                  className="block group-hover:hidden"
                />
                <img
                  src={Add_roundWhite}
                  alt=""
                  className="hidden group-hover:block"
                />
                <span className="">Add Duration</span>
              </div>
            </div>

            <div className="flex justify-between items-center font-semibold text-sm bg-[#CEC7FF4D] my-3 py-2 px-4 rounded">
              <span>Add-on Feature</span>
              {/* <img src={refreshLogo} alt="" className="bg-white p-1 rounded-md" /> */}
            </div>
            <div className="grid grid-cols-2 gap-4">
              {form.features.map((feature, featureIndex) => (
                <div
                  key={featureIndex}
                  className="w-full flex flex-col sm:flex-row relative"
                >
                  <input
                    type="text"
                    className="w-full pl-3 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none"
                    placeholder="Feature"
                    value={feature}
                    onChange={(e) =>
                      handleFeatureChange(index, featureIndex, e.target.value)
                    }
                  />
                  {form.features.length > 1 && featureIndex > 0 && (
                    <button
                      type="button"
                      onClick={() => handleRemoveFeature(index, featureIndex)}
                      className="absolute w-7 h-7 right-2 top-1 text-gray-400 hover:text-gray-200 font-bold "
                      title="Remove Feature"
                    >
                      ✕
                    </button>
                  )}
                </div>
              ))}
            </div>
            <div className="flex flex-col gap-4 sm:flex-row sm:w-1/2 justify-between ">
              <div
                className="flex justify-between items-center w-32 cursor-pointer rounded-md py-2 bg-[#CEC7FF4D] px-2
                hover:bg-primary text-primary hover:text-white hover:scale-105 transition-transform duration-300 group"
                onClick={() => handleAddFeature(index)}
                style={{ willChange: "transform" }}
              >
                <img
                  src={Add_round}
                  alt=""
                  className="block group-hover:hidden"
                />
                <img
                  src={Add_roundWhite}
                  alt=""
                  className="group-hover:block hidden"
                />
                <span className="">Add Feature</span>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="w-full flex justify-end">
        <div
          className="flex justify-between text-primary font-semibold border border-primary items-center text-sm  cursor-pointer rounded-md py-2  px-2
          hover:scale-105 transition-transform duration-300 hover:bg-primary hover:text-white"
          onClick={handleAddAnotherPlan}
          style={{ willChange: "transform" }}
        >
          <span className="">Add Another Add-On</span>
        </div>
      </div>

      <div className="w-full flex mt-5 flex justify-center">
        <button
          className="bg-primary py-2 w-64 rounded-md text-white font-semibold hover:scale-105 transition-transform duration-300"
          onClick={handleSubmit}
          style={{ willChange: "transform" }}
        >
          Save
        </button>
      </div>

      <AnimatePresence>
        {showSuccessModal && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-50 bg-black bg-opacity-50"
            />
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
              <motion.div
                initial={{ scale: 0.9, y: 20, opacity: 0 }}
                animate={{ scale: 1, y: 0, opacity: 1 }}
                exit={{ scale: 0.9, y: 20, opacity: 0 }}
                className="w-full max-w-md bg-white rounded-xl shadow-xl"
              >
                <div className="flex justify-center pt-8">
                  <div className="flex items-center justify-center w-20 h-20 rounded-full bg-green-50">
                    <motion.div
                      className="flex items-center justify-center w-20 h-20 rounded-full bg-green-50"
                      animate={{
                        rotate: [0, -10, 10, -10, 10, 0], // shake motion
                      }}
                      transition={{
                        duration: 0.6,
                        ease: "easeInOut",
                      }}
                    >
                      <svg
                        className="w-12 h-12 text-green-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </motion.div>
                  </div>
                </div>
                <div className="px-6 py-4 text-center">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">
                    Success!
                  </h3>
                  <p className="text-gray-600 mb-6">{apiMessage}</p>
                </div>
                <div className="px-6 pb-6">
                  <button
                    onClick={() => {setShowSuccessModal(false);
                      navigate("/myApplication")
                    }}
                    className="w-full py-3 px-4 bg-primary hover:bg-primary-dark text-white font-medium rounded-lg"
                  >
                    Continue
                  </button>
                </div>
              </motion.div>
            </div>
          </>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showErrorModal && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-50 bg-black bg-opacity-50"
            />
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
              <motion.div
                initial={{ scale: 0.9, y: 20, opacity: 0 }}
                animate={{ scale: 1, y: 0, opacity: 1 }}
                exit={{ scale: 0.9, y: 20, opacity: 0 }}
                className="w-full max-w-md bg-white rounded-xl shadow-xl"
              >
                <div className="flex justify-center pt-8">
                  <div className="flex items-center justify-center w-20 h-20 rounded-full bg-red-50">
                    <motion.div
                      className="flex items-center justify-center w-20 h-20 rounded-full bg-green-50"
                      animate={{
                        rotate: [0, -10, 10, -10, 10, 0], // shake motion
                      }}
                      transition={{
                        duration: 0.6,
                        ease: "easeInOut",
                      }}
                    >
                      <svg
                        className="w-8 h-8 text-red-500"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                      >
                        <path
                          strokeWidth={2}
                          strokeLinecap="round"
                          d="M12 8v4m0 4h.01M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z"
                        />
                      </svg>
                    </motion.div>
                  </div>
                </div>
                <div className="px-6 py-4 text-center">
                  <p className="text-gray-600 mb-6">{apiMessage}</p>
                </div>
                <div className="px-6 pb-6">
                  <button
                    onClick={() => setShowErrorModal(false)}
                    className="w-full py-3 px-4 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg"
                  >
                    Try Again
                  </button>
                </div>
              </motion.div>
            </div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CreateAddOn;
